import { render, staticRenderFns } from "./ContentFeedBaseView.vue?vue&type=template&id=1e0e4dff&scoped=true&"
import script from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedBaseView.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedBaseView.vue?vue&type=style&index=0&id=1e0e4dff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e4dff",
  null
  
)

export default component.exports